import ConfirmRegistration from "../ConfirmRegistration";
import BankInformationForm from "./BankInformationForm";

const BankInformation = ({
  handleChange,
  bankInformation,
  submit,
  addNewEmployee,
  handleClose,
}) => {
  return (
    <div className="formgrid grid">
      {!submit ? (
        <>
          <div className="field">
            <p className="heading">Bank Information</p>
            <p className="description">Bank Account Information for payment.</p>
          </div>
          <BankInformationForm
            bankInformation={bankInformation}
            handleChange={handleChange}
            isLoading={false}
            isEdit={true}
          />
        </>
      ) : (
        <ConfirmRegistration
          addNewEmployee={addNewEmployee}
          handleClose={handleClose}
        />
      )}
    </div>
  );
};

export default BankInformation;
